import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as agentsRoutes } from './agents/agents.routes';
import { routes as kanbanRoutes } from './kanban/routes';
import { routes as internalChatRoutes } from './internalChat/routes';
import { routes as galleryRoutes } from './gallery/routes';
import { routes as catalogRoutes } from './catalog/catalog.routes';
import { routes as takeoverRequestsRoutes } from './takeoverRequests/routes';
import { routes as socialRoutes } from './social/routes';
import { routes as assessmentsRoutes } from './assessments/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import PrivateChatView from './PrivateChatView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...agentsRoutes,
        ...kanbanRoutes,
        ...internalChatRoutes,
        ...inboxRoutes,
        ...galleryRoutes,
        ...catalogRoutes,
        ...takeoverRequestsRoutes,
        ...socialRoutes,
        ...assessmentsRoutes,
        {
          path: frontendURL('accounts/:accountId/notes'),
          name: 'account_notes',
          meta: { permissions: ['administrator', 'agent', 'custom_role'] },
          component: PrivateChatView,
        },
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
